import {Plural} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface ContactCardViewMoreButtonProps {
  additionalItemsCount: number;
  onClick: Handler;
}

/*
 * Style.
 */

const StyledButtonWrapperDiv = styled.div`
  display: flex;
  margin: -4px 0 -4px -12px;
`;

/*
 * Component.
 */

export const ContactCardViewMoreButton: FC<ContactCardViewMoreButtonProps> = (props) => {
  const {additionalItemsCount, onClick} = props;
  return (
    <StyledButtonWrapperDiv>
      <Button variant={ButtonVariantsEnum.LINK} size={VisualSizesEnum.SMALL} onClick={onClick}>
        <Plural
          id="contact-card-details-additional-items"
          value={additionalItemsCount}
          one="# more"
          other="# more"
        />
      </Button>
    </StyledButtonWrapperDiv>
  );
};
